import { useCallback } from 'react';
import { useGlobal as useGlobalReactN, getGlobal } from 'reactn';
import { produce } from 'immer';

let globalProp;
let setGlobalProp;

export const useGlobalInternal = (property) => {
  const cb = useCallback((prop) => {
    [globalProp, setGlobalProp] = useGlobalReactN(prop);
    return [globalProp, setGlobalProp, prop];
  }, [property]);
  return cb(property);
};

export const useGlobal = (prop) => {
  const [x, setX, xProp] = useGlobalInternal(prop);
  const wrappedSetX = (draftUpdater) => {
    const p = getGlobal()[xProp];
    if (typeof draftUpdater === 'function') {
      setX(produce(p, (newX) => {
        draftUpdater(newX);
      }));
    } else {
      setX(draftUpdater);
    }
  };
  return [x, wrappedSetX];
};

export default useGlobal;

